import { render, staticRenderFns } from "./AppealCard.vue?vue&type=template&id=1ed88a43&scoped=true&"
import script from "./AppealCard.vue?vue&type=script&lang=js&"
export * from "./AppealCard.vue?vue&type=script&lang=js&"
import style0 from "./AppealCard.vue?vue&type=style&index=0&id=1ed88a43&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed88a43",
  null
  
)

export default component.exports